import http from "infra/http";
import { useMutation } from "react-query";
import { RelatorioUnidadesQuery } from "core/features/relatorios/typings";
import { RelatorioUnidadesPdfResponse } from "core/features/relatorios/typings";
import { TipoUnidadePessoaEnum } from 'core/features/unidades/typings/unidade';

export default function useRelatorioUnidadesPdf(filtro: RelatorioUnidadesQuery) {
  return useMutation(
    [`/v1/relatorios/unidades/pdf`, filtro],
    async (tipoUnidadePessoaIds: TipoUnidadePessoaEnum[] = []) => {
      const url = "/v1/relatorios/unidades/pdf";

      const { data } = await http.get<RelatorioUnidadesPdfResponse>(url, {
        params: {
          ...filtro,
          tipoUnidadePessoaIds
        },
      });

      return data;
    }
  );
}
